import React, { useState, useContext, useMemo } from "react";

import { Row, Col, Image, Button, Tabs, Tab, Modal } from "react-bootstrap";
import DataGrid, { Row as GridRow } from "react-data-grid";
import { observer } from "mobx-react-lite";
import { Typeahead, ClearButton } from "react-bootstrap-typeahead";

import StoryContext from "../store/context";

const Order = observer(() => {
  const [show, setShow] = useState(false);
  const [listClients, setListClients] = useState([]);
  const [listRegions, setListRegions] = useState([]);
  const [listOutlets, setListOutlets] = useState([]);
  const store = useContext(StoryContext);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const TextEditor = ({ row, column }) => {
    return (
      <input
        className="textEditor"
        type="number"
        min={0}
        defaultValue={row[column.key]}
        onChange={(event) => {
          row.set({ ...row, [column.key]: Number(event.target.value) });
        }}
        autoFocus
      />
    );
  };

  const chekRegion = (store, region) => {
    const isRegions =
      region &&
      (store.filterRegions.length === 0 ||
        store.filterRegions.includes(region.uuid));

    return isRegions;
  };

  const columnsProducts = [
    {
      name: "Товар",
      key: "product",
      formatter({ row }) {
        return <>{row.product.name}</>;
      },
    },
    {
      name: "Залишок",
      key: "balance",
      formatter({ row }) {
        return <>{row.balance} </>;
      },
      editor: TextEditor,
    },
    {
      name: "Замовлення",
      key: "count",
      formatter({ row }) {
        return <>{row.count} </>;
      },
      editor: TextEditor,
    },
  ];

  const columnsOrders = [
    {
      name: "Клієнт",
      key: "client",
      formatter({ row }) {
        return <>{row.outlet.client.name}</>;
      },
    },
    {
      name: "Регіон",
      key: "region",
      formatter({ row }) {
        return <>{row.outlet.region.name}</>;
      },
    },
    {
      name: "Точка",
      key: "outlet",
      formatter({ row }) {
        return <>{row.outlet.name}</>;
      },
    },
    {
      name: "Час створення",
      key: "createat",
      formatter({ row }) {
        // console.log(111, row.createat);

        return (
          <>
            {row.createat &&
              new Intl.DateTimeFormat("ua-UA", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: false,
              }).format(new Date(row.createat))}
          </>
        );
      },
    },
  ];

  const onChangeDate = (value) => {
    store.orderStore.setDate(value);
  };

  const optionsClient = useMemo(
    () =>
      store.clients
        .filter((item) => item.active === true)
        .sort((s1, s2) =>
          s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
        )
        .map((item) => ({
          ...item,
          label: item.name,
          link: item,
          id: item.uuid,
        })),
    []
  );

  const optionsRegion = useMemo(() => {
    return store.regions
      .filter(
        (item) =>
          store.outlets
            .filter((it) => it.client === store.orderStore.curClient)
            .map((it) => it.region)
            .includes(item) && chekRegion(store, item)
      )
      .sort((s1, s2) =>
        s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
      )
      .map((item) => ({
        ...item,
        label: item.name,
        link: item,
      }));
  }, [store.orderStore.curClient]);

  const optionsOutlet = useMemo(() => {
    const r = store.outlets
      .filter(
        (item) =>
          item.client === store.orderStore.curClient &&
          (!store.orderStore.curRegion
            ? true
            : store.orderStore.curRegion === item.region) &&
          chekRegion(store, item.region)
      )
      .sort((s1, s2) =>
        s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
      )
      .map((item) => ({
        ...item,
        label: item.name,
        link: item,
      }));
    setListClients(
      optionsClient.filter((it) => it.link === store.orderStore.curClient)
    );
    setListRegions(
      optionsRegion.filter((it) => it.link === store.orderStore.curRegion)
    );
    setListOutlets(r.filter((it) => it.link === store.orderStore.curOutlet));
    return r;
  }, [store.orderStore.curClient, store.orderStore.curRegion]);

  const onRowClick = (item) => {
    store.orderStore.setCurOrder(item);
  };

  const removeOrder = () => {
    if (store.orderStore.curOrder) {
      store.orderStore.removeOrder();
    }
    handleClose();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Ви впевнені що хочете видалити цей заказ?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Ні
          </Button>
          <Button variant="primary" onClick={removeOrder}>
            Так
          </Button>
        </Modal.Footer>
      </Modal>
      <input
        name="requested_order_ship_date2"
        value={store.orderStore.date}
        type="date"
        className="form-control"
        onChange={(event) => {
          onChangeDate(event.target.value);
          setListClients([]);
          setListRegions([]);
          setListOutlets([]);
          store.orderStore.delCurOrder();
        }}
      />
      <Tabs
        defaultActiveKey="orders"
        id="uncontrolled2-tab-example"
        style={{ marginTop: 5 }}
      >
        <Tab eventKey="orders" title="Закази" style={{ height: "80vh" }}>
          <DataGrid
            style={{ height: 600, marginTop: 5 }}
            columns={columnsOrders}
            rows={store.orderStore.orders}
            defaultColumnOptions={{
              sortable: true,
              resizable: true,
            }}
            onRowClick={(item) => onRowClick(item)}
          />
        </Tab>
        <Tab eventKey="poducts" title="Товари" style={{ height: "80vh" }}>
          <Row style={{ marginTop: 5 }}>
            <Col>
              <Typeahead
                onChange={
                  (value) => {
                    if (value.length > 0) {
                      store.orderStore.setCurClient(value[0].link);
                      setListClients(value);
                    }
                  }

                  // console.log(value)
                }
                options={optionsClient}
                selected={listClients}
                placeholder="Клиент..."
              >
                {({ selected }) => (
                  <div className="rbt-aux">
                    {!!selected.length && (
                      <ClearButton
                        onClick={() => {
                          setListClients([]);
                          setListRegions([]);
                          setListOutlets([]);
                          store.orderStore.delCurOrder();
                          store.orderStore.delCurClient();
                        }}
                      />
                    )}
                  </div>
                )}
              </Typeahead>
            </Col>
            <Col>
              <Typeahead
                onChange={(value) => {
                  if (value.length > 0) {
                    store.orderStore.setCurRegion(value[0].link);
                    store.orderStore.delCurOutlet();
                    setListRegions(value);
                    setListOutlets([]);
                    store.orderStore.delCurOrder();
                  }
                }}
                options={optionsRegion}
                placeholder="Область..."
                selected={listRegions}
              >
                {({ selected }) => (
                  <div className="rbt-aux">
                    {!!selected.length && (
                      <ClearButton
                        onClick={() => {
                          setListRegions([]);
                          setListOutlets([]);
                          store.orderStore.delCurRegion();
                          store.orderStore.delCurOrder();
                        }}
                      />
                    )}
                  </div>
                )}
              </Typeahead>
            </Col>
            <Col md={5}>
              <Typeahead
                onChange={(value) => {
                  if (value.length > 0) {
                    store.orderStore.setCurOutlet(value[0].link);
                    setListOutlets(value);
                    store.orderStore.delCurOrder();
                  }
                }}
                options={optionsOutlet}
                placeholder="Точка..."
                selected={listOutlets}
              >
                {({ selected }) => (
                  <div className="rbt-aux">
                    {!!selected.length && (
                      <ClearButton
                        onClick={() => {
                          setListOutlets([]);
                          store.orderStore.delCurOutlet();
                          store.orderStore.delCurOrder();
                        }}
                      />
                    )}
                  </div>
                )}
              </Typeahead>
            </Col>
            <Col md={2}>
              <Button
                style={{ padding: 5 }}
                onClick={() => {
                  store.orderStore.getOrderByOutlet();
                }}
              >
                Заповнити
              </Button>
              <Button
                style={{ padding: 5, marginLeft: 5 }}
                onClick={() => {
                  store.orderStore.saveOrder();
                }}
              >
                Зберегти
              </Button>
              <Button
                style={{ padding: 5, marginLeft: 5 }}
                onClick={handleShow}
              >
                Выдалити
              </Button>
            </Col>
          </Row>

          <DataGrid
            style={{ height: 600, marginTop: 5 }}
            columns={columnsProducts}
            rows={
              store.orderStore.curOrder
                ? store.orderStore.curOrder.items
                    .slice()
                    .sort((s1, s2) =>
                      s1.product.name.toLowerCase() <
                      s2.product.name.toLowerCase()
                        ? -1
                        : 1
                    )
                : []
            }
            defaultColumnOptions={{
              sortable: true,
              resizable: true,
            }}
          />
        </Tab>
      </Tabs>
    </>
  );
});

export default Order;
